import "scripts/templates/page.landing-new.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.landing-new");
